<template>
  <div :class="$style.container">
    <div
      :class="[$style.arrow, { [$style.expanded]: !isOpened }]"
      @click="toggle"
    >
      <img src="@/assets/images/icons/navigation/big-arrow.svg">
    </div>

    <h1 v-show="isOpened">
      ОТОБРАЖЕНИЕ
    </h1>

    <scrollable-container :class="$style.scrollable">
      <tree-menu
        v-for="node in computersTree"
        v-show="isOpened"
        :id="node.id + node.type"
        :key="node.id + node.type"
        :name="getName(node)"
        :nodes="node.children"
        :checked="node.checked"
        :depth="0"
        :is-folder="node.type === 'folder'"
      />
    </scrollable-container>
  </div>
</template>

<script>
import { getComputers } from '@/api/methods/computers';
import ScrollableContainer from '@/components/common/blocks/scrollable-container.vue';
import TreeMenu from './tree-menu.vue';

export default {
  components: {
    TreeMenu,
    ScrollableContainer,
  },
  props: ['text', 'value', 'isOpened'],
  data: () => ({
    tree: [],
    computers: [],
  }),
  computed: {
    computersTree() {
      return this.$store.getters['pageSpecificData/computersTree'];
    },
    checkedComputerId() {
      return this.$store.getters['pageSpecificData/checkedComputerId'];
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      return getComputers().then(({ tree, computers }) => {
        this.tree = tree;
        this.computers = computers;
        const computerId = this.checkedComputerId;

        if (!computerId) tree.forEach((item) => this.addChecked(item, false));
        else tree.forEach((item) => this.addChecked(item, computerId));
        this.sendTree();
      });
    },
    toggle() {
      this.$emit('toggle');
    },
    getName(node) {
      if (node.type === 'computer') return node.nameUser;
      return node.name;
    },
    sendTree() {
      this.$store.commit('pageSpecificData/setComputerTree', this.tree);
    },
    addChecked(node, value) {
      if (!value) node.checked = true;
      else if (node.id.toString() === value) {
        node.checked = true;
      } else node.checked = false;
      if (node.type === 'folder') {
        node.children.forEach((child) => {
          this.addChecked(child, value);
        });
      }
    },
  },
};
</script>

<style lang="scss" module>
.container {
  height: 100%;
}

.scrollable {
  overflow-x: hidden;
  height: calc(100% - 30px);
}

h1 {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: $black;
  margin-bottom: 20px;
  display: inline-flex;
  margin-left: 20px;
}

.arrow {
  cursor: pointer;
  display: inline-flex;
  transform: rotate(-90deg);
}

.expanded {
  transform: rotate(90deg);
}
</style>
